<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <h2 class="large_label">完了案件一覧</h2>
      <div>
        <p class="bold_label" v-if="customClaim.isOwner">
          <input type="checkbox" v-model="isVisibleStaffMatchings">
          従業員の案件も表示
        </p>
      </div>
      <template v-for="(matching, index) in matchings">
        <MatchingBox :key="index" :matching="matching"/>
      </template>
    </div>
  </div>
</template>

<script>
  import RetrievingMatchings from "@/assets/js/pages/mypage/operator/RetrievingMatchings";
  import {mapGetters} from "vuex";
  import collection from "@/assets/js/functions/firebase/firestore/collection";
  import STATUSES from "@/assets/js/constants/statuses";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";

  import MatchingBox from "@/components/molecules/box/MatchingBox";

  export default {
    name: "RetrievingMatchings",

    components: {MatchingBox},

    mixins: [RetrievingMatchings, collection],

    data() {
      return {
        matchings: [],
        staffs: [],
        selectedStatus: '',
        isVisibleStaffMatchings: false,
      }
    },

    computed: {
      ...mapGetters({office: 'auth/office', uid: 'auth/uid', customClaim: 'auth/customClaim'}),
    },

    watch: {
      isVisibleStaffMatchings: {
        handler: function () {
          this.isVisibleStaffMatchings ? this.retrieveStaffMatchingsIncluded() : this.retrieveMatchings()
        }
      },
    },

    beforeCreate() {
      Object.assign(this, {STATUSES});
      Object.assign(this, {COLLECTION_NAMES});
    },

    async created() {
      await this.retrieveMatchings();
    },

    methods: {
      async retrieveMatchings() {
        const operator = this.getDocPath(COLLECTION_NAMES.OPERATORS, this.uid);
        const query = this.getDocRef(COLLECTION_NAMES.MATCHINGS).where(
          "status", "==", STATUSES.COMPLETION.name
        ).where(
          "isDeleted", "==", false
        ).where(
          'operator', '==', operator
        ).orderBy('createdAt');
        await this.retrieveDocs(query).then(docs => {
          this.matchings = docs;
        });
      },

      async retrieveStaffMatchingsIncluded() {
        const officePath = this.getDocPath(COLLECTION_NAMES.OFFICES, this.office.id);
        const query = this.getDocRef(COLLECTION_NAMES.MATCHINGS).where(
          "status", "==", STATUSES.COMPLETION.name
        ).where(
          "isDeleted", "==", false
        ).where(
          'operatorOffice', '==', officePath
        ).orderBy('createdAt');
        await this.retrieveDocs(query).then(docs => {
          this.matchings = docs;
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background: linear-gradient(45deg, $client_third, $client_third, $operator_secondary, $operator_secondary);

    > .contents {
      @include index-contents();

      > div {
        display: flex;
        flex-flow: column;
        justify-content: flex-end;
        width: 100%;

        > select {
          margin: 2rem 0 1rem 0;
        }
      }
    }
  }
</style>